const formatVideoDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  } else {
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
};

export const formatVideoDurationWithChannel = (
  durationInSeconds: number,
  channelTitle: string
): string => {
  const formattedDuration = formatVideoDuration(durationInSeconds);
  return `${formattedDuration} • ${channelTitle}`;
};
